import { SearchPlacesByKeywordRequest } from '../../api/requests/place-request.ts';
import { searchPlacesByKeyword } from '../../api/place.ts';
import { useQuery } from '@tanstack/react-query';

export default function useSearchPlacesByKeyword(
  query: SearchPlacesByKeywordRequest,
) {
  const { data, isLoading, error } = useQuery({
    queryKey: ['places', 'search', query],
    queryFn: () => searchPlacesByKeyword(query),
    enabled: !!query.keywords.length,
  });

  return {
    data,
    isLoading,
    error,
  };
}
